import EmailApiSagas from 'emailApp/sagas'; /* eslint-disable-line import/no-unresolved */
import singleLeadsVerificationSagas from 'evsApp/singleLeads/sagas'; /* eslint-disable-line import/no-unresolved */
import fileVerificationSagas from 'evsApp/verificationFiles/sagas'; /* eslint-disable-line import/no-unresolved */
import { all } from 'redux-saga/effects';

import accountSagas from './account';
import authSagas from './auth';
import automationsSaga from './automations';
import campaignSagas from './campaigns';
import campaignCreator from './campaignCreator';
import contactSagas from './contacts';
import customFieldsSagas from './customFields';
import deviceDetailsSaga from './deviceDetails';
import domainSagas from './domain';
import emailsSagas from './emails';
import exportSagas from './export';
import formListSagas from './formList';
import locationSagas from './geography';
import inboundSagas from './inbound';
import landingPageListSagas from './landingPageList';
import listSagas from './lists';
import NotificationSagas from './notification';
import poolsSagas from './pools';
import productSagas from './products';
import rawEditorSagas from './rawEditor';
import reportSagas from './reports';
import securitySagas from './security';
import segmentSagas from './segments';
import sessionSagas from './session';
import subAccountSagas from './subaccounts';
import templateListSagas from './templateList';
import templateTagListSagas from './templateTagList';
import uploadSagas from './upload';
import UserFilesSaga from './userFiles';
import UsersSagas from './users';
import validEmailsSagas from './validEmails';
import webhooksSagas from './webhooks';
import PaymentsSagas from './payments';
import TemplateEditorSagas from './templateEditor';
import onboardingSurveySagas from './onboardingSurvey';
import integrationsSagas from './integrations';
import brandColorsSagas from './brandColors';
import dashboardSettingsSagas from './dashboardSettings';
import prebuildModulesSagas from './prebuildModules';
import aiTextSagas from './aiText';
import dashboardSeenNotificationsSagas from './dashboardSeenNotifications';
import onboardingSagas from './onboarding';
import formCreatorSagas from './formCreator';
import landingPageCreatorSagas from './landingPageCreator';
import mergeFieldsSagas from './mergeFields';
import landingPageSubdomainSagas from './landingPageSubdomain';
import checkoutCreatorSagas from './checkoutCreator';
import checkoutsListSagas from './checkoutsList';
import checkoutsSagas from './checkoutsTerms';
import checkoutsStripeAccountSagas from './checkoutsStripeAccount';
import paidNewslettersListSagas from './paidNewslettersList';
import paidNewslettersCreatorSagas from './paidNewsletterCreator';
import paidNewslettersStripeAccountSagas from './paidNewslettersStripeAccount';
import paidNewslettersTermsSagas from './paidNewslettersTerms';

// import toastSagas from './toast';
// notice how we now only export the rootSaga
// single entry point to start all Sagas at once
export default function* rootSaga(): any {
    yield all([
        ...uploadSagas,
        ...UserFilesSaga,
        ...deviceDetailsSaga,
        ...locationSagas,
        ...listSagas,
        ...segmentSagas,
        ...customFieldsSagas,
        ...exportSagas,
        ...campaignSagas,
        ...campaignCreator,
        ...reportSagas,
        ...templateListSagas,
        ...templateTagListSagas,
        ...landingPageListSagas,
        ...rawEditorSagas,
        ...accountSagas,
        ...contactSagas,
        ...domainSagas,
        ...inboundSagas,
        ...poolsSagas,
        ...securitySagas,
        ...validEmailsSagas,
        ...webhooksSagas,
        ...sessionSagas,
        ...emailsSagas,
        ...subAccountSagas,
        ...productSagas,
        ...automationsSaga,
        ...authSagas,
        ...NotificationSagas,
        ...UsersSagas,
        ...formListSagas,
        ...PaymentsSagas,
        ...onboardingSurveySagas,
        ...integrationsSagas,
        ...singleLeadsVerificationSagas,
        ...fileVerificationSagas,
        ...EmailApiSagas,
        ...TemplateEditorSagas,
        ...brandColorsSagas,
        ...dashboardSettingsSagas,
        ...prebuildModulesSagas,
        ...aiTextSagas,
        ...dashboardSeenNotificationsSagas,
        ...onboardingSagas,
        ...formCreatorSagas,
        ...landingPageCreatorSagas,
        ...mergeFieldsSagas,
        ...landingPageSubdomainSagas,
        ...checkoutCreatorSagas,
        ...checkoutsListSagas,
        ...checkoutsSagas,
        ...checkoutsStripeAccountSagas,
        ...paidNewslettersListSagas,
        ...paidNewslettersCreatorSagas,
        ...paidNewslettersStripeAccountSagas,
        ...paidNewslettersTermsSagas,
    ]);
}
